import { ajax } from '../index'

/**
 * Top Reviews相关接口
 */
export default {
  // 获取top review数据
  getTopReview(params: string | number) {
    return ajax.get('api', `/api/v1/product/list/top-reviewed${params}`, {})
  },

  // 获取侧边interesting数据
  getInteresting() {
    return ajax.get('api', `/api/v1/mooncake/interesting`, {})
  }
}